// extracted by mini-css-extract-plugin
module.exports = {"UIContainer":"UIContainer_UIContainer__cCILT","UIModalContainer":"UIContainer_UIModalContainer__q0XNf"};